import { create } from "zustand";
import { CanvasNodeContent } from "../models/CanvasNodeContent";
import { CanvasEdge } from "../models/CanvasEdge.ts";
import { CanvasNode } from "../models/CanvasNode.ts";
import workflow from "../assets/sidepanel/workflow.png";
import axios from "axios";
import { Environment } from "../environment.ts";

export interface Attribute {
  attributeId: string;
  attributeName: string;
  attributeType: string;
  businessId?: string;
}

interface FlowState {
  nodes: CanvasNode[];
  edges: CanvasEdge[];
  nodeContent: CanvasNodeContent[];
  flowId: string;
  businessId: string;
  businessAttributes: Attribute[];
  systemAttributes: string[];
  isLoadingAttributes: boolean;
  getViewportCenter: (() => { x: number; y: number } | null) | null;

  setNodes: (nodes: CanvasNode[]) => void;
  setEdges: (edges: CanvasEdge[]) => void;
  setNodeContent: (content: CanvasNodeContent[]) => void;
  setFlowId: (flowId: string) => void;
  setBusinessId: (businessId: string) => void;
  setGetViewportCenter: (fn: (() => { x: number; y: number } | null) | null) => void;

  fetchBusinessAttributes: () => Promise<void>;
  fetchSystemAttributes: () => Promise<void>;
}

export const useFlowStore = create<FlowState>((set, get) => ({
  nodes: [new CanvasNode({ type: "FLOW_START", name: "Flow Start", icon: workflow })],
  edges: [],
  nodeContent: [],
  flowId: "",
  businessId: "",
  businessAttributes: [],
  systemAttributes: [],
  isLoadingAttributes: false,
  getViewportCenter: null,

  setNodes: (nodes) => set({ nodes }),
  setEdges: (edges) => set({ edges }),
  setNodeContent: (nodeContent) => set({ nodeContent }),
  setFlowId: (flowId) => set({ flowId }),
  setGetViewportCenter: (fn) => set({ getViewportCenter: fn }),
  setBusinessId: (businessId) => {
    set({ businessId });
    if (businessId) {
      get().fetchBusinessAttributes();
      get().fetchSystemAttributes();
    }
  },

  fetchBusinessAttributes: async () => {
    const { businessId } = get();
    if (!businessId) return;
    
    set({ isLoadingAttributes: true });
    try {
      const response = await axios.get(`${Environment.baseUrl}/meta/business-attributes?businessId=${businessId}`);
      set({ businessAttributes: response.data.data || [], isLoadingAttributes: false });
    } catch (error) {
      console.error("Failed to fetch business attributes", error);
      set({ isLoadingAttributes: false });
    }
  },

  fetchSystemAttributes: async () => {
    try {
      const response = await axios.get(`${Environment.baseUrl}/meta/system-attributes`);
      set({ systemAttributes: response.data.data || [] });
    } catch (error) {
      console.error("Failed to fetch system attributes", error);
    }
  }
}));
